import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: () => import('../views/Imprint.vue')
  },
  {
    path: '/datenschutz',
    name: 'dataPrivacy',
    component: () => import('../views/DataPrivacy.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes
})

export default router
